import { TOPIC_TREE_REQUESTED, TOPIC_TREE_SUCCESS, TOPIC_TREE_ERROR } from './TopicTree-Actions';

const initialState = {
  topics: [],
  isLoading: false,
  isError: false,
  error: null,
  experience: undefined,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
    case TOPIC_TREE_REQUESTED: {
      return { ...initialState, ...{ topics: [], isLoading: true } };
    }

    case TOPIC_TREE_SUCCESS: {
      return {
        ...initialState,
        ...{ topics: action.payload.topics, isLoading: false, experience: action.payload.experience },
      };
    }

    case TOPIC_TREE_ERROR: {
      return { ...initialState, ...{ topics: [], isLoading: false, isError: true } };
    }
    default:
      return state;
  }
};

export default Reducer;
